import React from 'react';
import PropTypes from 'prop-types';
import { ContentSwitch } from 'Components';
import './TruncateToolTip.css';

const TruncateToolTip = (props) => {
  const { text, delimiter } = props;

  const input = text || '';
  return (
    <div className="truncate__tooltip">
      {input.length > props.maxLength ? `${input.substring(0, props.maxLength)}...` : input}
      <span className="truncate__tooltip__text">
        <ContentSwitch index={Number(delimiter === undefined)}>
          <ul>
            {input.split(delimiter).map(item => <li key={item}>{item}</li>)}
          </ul>
          <span>{input}</span>
        </ContentSwitch>
      </span>
    </div>);
};

TruncateToolTip.propTypes = {
  text: PropTypes.string,
  delimiter: PropTypes.string,
  maxLength: PropTypes.number,
};

TruncateToolTip.defaultProps = {
  text: '',
  maxLength: 40,
};

export default TruncateToolTip;



// WEBPACK FOOTER //
// ./src/components/TruncateToolTip/TruncateToolTip.jsx